// Asks the Chrome extension installed in THIS browser to act as `userId`.
// Talks to the extension's content-app-bridge.js via window.postMessage.
//
// Resolves to:
//   { via: "extension", success: true,  userId }        – extension confirmed
//   { via: "extension", success: false, userId, error } – extension failed
//   { via: "none" }                                     – no bridge (older extension)
export const setExtensionActiveUser = (
  userId,
  { ackTimeoutMs = 1000, resultTimeoutMs = 20000 } = {},
) =>
  new Promise((resolve) => {
    const requestId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let ackTimer;
    let resultTimer;

    const finish = (result) => {
      clearTimeout(ackTimer);
      clearTimeout(resultTimer);
      window.removeEventListener("message", onMessage);
      resolve(result);
    };

    function onMessage(event) {
      const msg = event.data;
      if (event.source !== window || !msg || msg.source !== "thriftops-extension") return;
      if (msg.requestId !== requestId) return;

      if (msg.type === "SET_ACTIVE_USER_ACK") {
        clearTimeout(ackTimer);
      } else if (msg.type === "SET_ACTIVE_USER_RESULT") {
        finish({
          via: "extension",
          success: Boolean(msg.success),
          userId: msg.userId,
          error: msg.error,
        });
      }
    }

    window.addEventListener("message", onMessage);
    ackTimer = setTimeout(() => finish({ via: "none" }), ackTimeoutMs);
    resultTimer = setTimeout(
      () =>
        finish({
          via: "extension",
          success: false,
          userId: String(userId),
          error: "timed out waiting for the extension",
        }),
      resultTimeoutMs,
    );

    window.postMessage(
      { source: "thriftops-app", type: "SET_ACTIVE_USER", requestId, userId: String(userId) },
      window.location.origin,
    );
  });
